import fire from './Firebase';
import {getDatabase , ref, set} from "firebase/database";

const realTimeDB = getDatabase(fire);

export default realTimeDB;
